import React from "react"
import { Box, CircularProgress } from "@material-ui/core"

const FullscreenSpinner = () => {
  return (
    <Box
      style={{ width: "100vw", height: "100vh" }}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress color="primary" />
    </Box>
  )
}

export default FullscreenSpinner



// WEBPACK FOOTER //
// ./src/components/FullscreenSpinner/index.jsx